import type { ActivityStatus } from '../../types/activity';

export const ACTIVITY_STATUS_LABELS: Record<ActivityStatus, string> = {
  draft: 'Draft',
  published: 'Live',
  unpublished: 'Unpublished',
  archived: 'Archived',
};

export const ACTIVITY_STATUS_DOT: Record<ActivityStatus, string> = {
  draft: 'bg-pine-draft',
  published: 'bg-pine-approved',
  unpublished: 'bg-pine-line',
  archived: 'bg-pine-danger',
};

export const ACTIVITY_STATUS_BADGE: Record<ActivityStatus, string> = {
  draft: 'border-[1.5px] border-pine-draft text-pine-draft bg-white',
  published: 'border-[1.5px] border-pine-approved text-pine-approved bg-white',
  unpublished: 'border-[1.5px] border-pine-draft text-pine-draft bg-white',
  archived: 'border-[1.5px] border-pine-danger text-pine-danger bg-white',
};
